import React from 'react';
import About from '../../components/About/About';

const AboutPage: React.FC = () => {
  return (
    <main>
      <About />
    </main>
  );
};

export default AboutPage;